// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-preview[data-v-33c494e0]{background-color:#efefef;position:absolute;top:0;left:0;min-height:calc(100vh - var(--admin-bar-height, 0px));width:100vw;display:flex;flex-direction:column;align-items:center}", ""]);
// Exports
module.exports = exports;
